import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class NewsResource extends BaseCamelCasedResource {
    pk() {
        return this.newsItemId?.toString();
    }
}
NewsResource.urlRoot = legacyApiResourceUrl("Information/GetNews");
//# sourceMappingURL=NewsResource.js.map